import setToken from "../../util/SetToken";

import jwt_decode from "jwt-decode";
import { key } from "../../util/Config";
import setDevKey from "../../util/SetDevKey";

 
import { GET_SELLER, SET_ADMIN, UNSET_ADMIN, UPDATE_PROFILE } from "./types";


const initialState = {
  isAuth: false,
  admin: {},
  seller: {},
};

const adminReducer = (state = initialState, action) => {
  
  let decoded;

  switch (action.type) {
    case SET_ADMIN:
      
      if (action.payload) {
        
        decoded = jwt_decode(action.payload);
      }
      setToken(action.payload);
      setDevKey(key);
      localStorage.setItem("TOKEN", action.payload);
      localStorage.setItem("KEY", key);
      return {
        ...state,
        isAuth: true,
        admin: decoded,
      };

    case UNSET_ADMIN:
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("KEY");
    
      setDevKey(null);
      setToken(null);
      return {
        ...state,
        isAuth: false,
        admin: {},
      };

    case UPDATE_PROFILE:
      return {
        ...state,
        admin: {
          ...state.admin,
          _id: action.payload._id,
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          flag: action.payload.flag,
        },
      };


      case GET_SELLER:
      return {
        ...state,
        seller:action?.payload
      }
    default:
      return state;
  }
};

export default adminReducer;
